import style from './why-hire-dedicated-team.module.scss';
import template from '@components/services/services.module.scss';
import Image from 'next/image';
import { IWhyHireDedicatedTeamListItem } from '@components/services/dedicated-teams/dedicated-teams.state';

interface IWhyHireDedicatedTeamProps {
  title: string;
  description: string;
  items: IWhyHireDedicatedTeamListItem[];
}

const WhyHireDedicatedTeamSection = ({ title, description, items }: IWhyHireDedicatedTeamProps) => {
  return (
    <section className={`${template.section} ${template.section_gray} ${style.section}`}>
      <div className={`${template.container} ${style.whyHire__header}`}>
        <div
          className={`${template.title} ${template.title_large} ${template.mb20} ${template.text_align_c} ${style.whyHire__title}`}
        >
          <h2 className={`${template.title_large}`}>{title}</h2>
        </div>
        <div
          className={`${template.mb40} ${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c} ${template.fw400}`}
        >
          {description}
        </div>
      </div>
      <div className={`${template.container} ${template.container_large}`}>
        <div className={`${style.whyHire_items}`}>
          {items.map((item: IWhyHireDedicatedTeamListItem, index: number) => {
            return (
              <div className={`${style.whyHire_item} ${template.section_light}`} key={index}>
                <div className={`${style.whyHire_item_header} ${template.mb20}`}>
                  <div className={`${style.whyHire_item_order} ${template.mr16}`}>{item.order}</div>
                  <div className={`${template.text} ${template.text_color_main} ${style.whyHire_item_header_text}`}>
                    {item.title}
                  </div>
                </div>
                <div className={`${style.whyHire_item_text}`}>{item.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyHireDedicatedTeamSection;
